export class HealthConnectNotAvailableException extends Error {
    constructor(message?: string, options?: ErrorOptions) {
        super(message ?? 'Health Connect is not available', options);
    }
}
